import type { Except } from "type-fest";
import { z } from "zod";
import { cartIdZodSchema } from "../carts/cart-id";
import { isoAndUnixZodSchema, nowIsoAndUnix } from "../date-time/iso-and-unix";

const stockBalanceSkuQuantityProjectionZodSchema = z.object({
    _type: z.literal("STOCK_BALANCE_SKU_QUANTITY_PROJECTION"),
    _createdAt: isoAndUnixZodSchema,
    quantity: z.number().int(),
    version: z.number().int().min(1),
    ofWhich: z.object({
        pendingReservations: z.number().int().min(0),
    }),
    cartIgnored: cartIdZodSchema.optional(),
});

type StockBalanceSkuQuantityProjection = z.infer<
    typeof stockBalanceSkuQuantityProjectionZodSchema
>;

type FactoryParams = Except<
    StockBalanceSkuQuantityProjection,
    "_type" | "_createdAt"
>;
const stockBalanceSkuQuantityProjectionFactory = (
    params: FactoryParams,
): StockBalanceSkuQuantityProjection => ({
    ...params,
    _type: "STOCK_BALANCE_SKU_QUANTITY_PROJECTION",
    _createdAt: nowIsoAndUnix(),
});

export {
    stockBalanceSkuQuantityProjectionFactory,
    stockBalanceSkuQuantityProjectionZodSchema,
};
export type { StockBalanceSkuQuantityProjection };
